var map = {
	"./ALFA switchgear.jpeg": 2785,
	"./Botswana International University of Science and Technology.jpeg": 98499,
	"./Coral Manufacturing works.jpeg": 2395,
	"./EIE MOU- ABB company Logo.jpg": 40945,
	"./PRDC.jpeg": 65949,
	"./REVOLT.jpeg": 29224,
	"./SurveySparrow.png": 65031,
	"./UTP-logo.png": 65290,
	"./ambalauto.jpg": 7807,
	"./ancit.jpg": 63490,
	"./ark.jpg": 68673,
	"./delphi-tvs.png": 24531,
	"./digiplus.jpg": 74732,
	"./equad.jpeg": 75870,
	"./fortinet.jpg": 97000,
	"./infosys.jpg": 76330,
	"./marlboro.jpeg": 9422,
	"./mistral.jpeg": 93270,
	"./niyata.webp": 19839,
	"./ntt.png": 10359,
	"./pcra.jpeg": 28010,
	"./pentafox.png": 92550,
	"./pstpa.jpeg": 71942,
	"./rn.png": 90933,
	"./schneider.jpeg": 2535,
	"./semarang.jpeg": 8822,
	"./tni.jpeg": 8711,
	"./vinpower.jpeg": 63920,
	"./virtusa.webp": 23827,
	"./vps.jpg": 5384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97274;